import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import { Button } from '@cian/ui-kit/button';
import { TDeviceType } from '@cian/ui-kit/responsive';

const styles = require('./CookieAgreementBar.css');

interface ICookieAgreementBar {
  deviceType: TDeviceType;

  onViewAgreement(event: React.SyntheticEvent<HTMLAnchorElement>): void;
  onAccept(): void;
}

export const CookieAgreementBar: React.FC<ICookieAgreementBar> = ({ deviceType, onAccept, onViewAgreement }) => {
  return (
    <div
      {...mergeStyles(
        styles['container'],
        deviceType === 'desktop' && styles['fixed'],
        deviceType !== 'desktop' && styles['adaptive'],
      )}
    >
      <div className={styles['text-container']}>
        Мы используем файлы cookie.{' '}
        <a href="#" className={styles['view-agreement']} onClick={onViewAgreement}>
          Соглашение об использовании
        </a>
      </div>
      <div className={styles['button-wrapper']}>
        <Button onClick={onAccept} theme="fill_white_primary">
          Принять
        </Button>
      </div>
    </div>
  );
};

CookieAgreementBar.displayName = 'CookieAgreementBar';
